import { useMemo } from 'react'
import { Box } from '@mui/material'
import {
  getPanelHistory,
  useHistoryCustomBack,
  useNavigate,
  usePanelHistoryTop,
} from 'weblite-router'
import { VisibilityHandler } from './components/visibility-handler'
import { NAVIGATION_BAR_HEIGHT } from '$common/navigation-bar'
import { StaticPanelWappId } from '$logic/wapp-panels'
import { StaticWappPanel } from '$comp/static-wapp-panel'
import { HomePanel } from './router-panels/router-panels'
import { useProfile } from '$logic/profile/react-hook'
import { UserRole } from '$logic/profile/types'
import { isUserTeacher } from '$logic/profile'

export function Vitrine() {
  const navigate = useNavigate()
  const profile = useProfile()

  const homePanelState = usePanelHistoryTop('home')?.state
  const isTop = homePanelState?.tab === 'vitrine'

  useHistoryCustomBack(
    () => {
      const panelHistory = getPanelHistory('vitrine')
      if (panelHistory.length > 1) navigate(-1)
      else
        HomePanel.navigate('home', {
          replace: true,
          absolute: true,
          data: { tab: 'roomList' },
        })
    },
    [],
    isTop,
  )

  const wapprunnerKey = useMemo(() => {
    const eduProfile = profile?.school
    if (isUserTeacher(eduProfile?.role)) {
      return eduProfile.role + eduProfile.specialities?.join('')
    }
    if (eduProfile?.role === UserRole.STUDENT) {
      return eduProfile.role + eduProfile.base + eduProfile.major
    }
    return ''
  }, [profile])

  return null
  return (
    <VisibilityHandler zIndex={1} considerIOSNotch>
      <Box sx={{ height: `calc(100% - ${NAVIGATION_BAR_HEIGHT}px)` }}>
        <StaticWappPanel
          panelName="vitrine"
          wappId={StaticPanelWappId.VITRINE}
          input={{}}
          wapprunnerKey={wapprunnerKey}
        />
      </Box>
    </VisibilityHandler>
  )
}
